import Header from "@/components/header";
import Sidebar from "@/components/sidebar";
import { JSX, ReactNode } from "react";

interface CommonShellProps {
	children: ReactNode;
}

function CommonShell({ children }: CommonShellProps): JSX.Element {
	return (
		<>
			<Header />
			<Sidebar />
			<div className="account">{children}</div>
		</>
	);
}

export default CommonShell;
